import React, { useState, useEffect } from "react";
import UserManagement from "../../../components/UserManagement/UserManagement";
import { fetchData } from "../../../api/apiService";
import { fetchUserData } from "../../../components/SecurityComponent/SecurityComponent";

const UserManagementPage = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const userPermission = await fetchUserData();
        console.log("fetchUserData", userPermission.user.roles);
        const hasAdminRole = userPermission.user.roles.some(
          (role) => role.isAdmin === true
        );
        const endpoint = hasAdminRole
          ? "/roles?isReturnAll=true"
          : "/roles?isAdmin=false";

        const fetchedData = await fetchData(endpoint);
        setRoles(fetchedData.roles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  return <UserManagement roles={roles} />;
};

export default UserManagementPage;
